import { useState } from 'react';
import './GachaMachine3D.css';
import './DonationSection.css';

export function DonationSection() {
  const [showCreditsModal, setShowCreditsModal] = useState(false);

  return (
    <>
      <section className="gacha-machine-3d-section">
        <div className="gacha-machine-3d-container">
          <div className="gacha-machine-3d__donation">
            <div className="gacha-machine-3d__donation-header">
              <h3>후원하기</h3>
              <p className="gacha-machine-3d__donation-notice">
                후원 시 후원금액과 이름을 다음 크레딧에 올려드립니다
              </p>
              <p className="gacha-machine-3d__donation-purpose">
                후원은 DSM-TCG 운영비에 사용됩니다
              </p>
            </div>

            <div className="gacha-machine-3d__donation-info">
              <div className="gacha-machine-3d__donation-account">
                <div className="gacha-machine-3d__donation-account-label">후원 계좌</div>
                <div className="gacha-machine-3d__donation-account-value">
                  <div>은행: 토스뱅크</div>
                  <div>계좌번호: 1000-6609-4479</div>
                  <div>예금주: 이용진</div>
                </div>
              </div>

              <button 
                className="gacha-machine-3d__donation-credits-btn"
                onClick={() => setShowCreditsModal(true)}
              >
                크레딧 보기
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 크레딧 모달 */}
      {showCreditsModal && (
        <div className="credits-modal-overlay" onClick={() => setShowCreditsModal(false)}>
          <div className="credits-modal" onClick={(e) => e.stopPropagation()}>
            <div className="credits-modal__header">
              <h2>크레딧</h2>
              <button 
                className="credits-modal__close"
                onClick={() => setShowCreditsModal(false)}
                aria-label="닫기"
              >
                ×
              </button>
            </div>
            <div className="credits-modal__content">
              <p className="credits-modal__description">
                DSM-TCG를 후원해주신 분들께 감사드립니다.
              </p>
              <div className="credits-modal__list">
                <div className="credits-modal__item">
                  <div className="credits-modal__item-name">이용진</div>
                  <div className="credits-modal__item-amount">100,000원</div>
                </div>
              </div>
              <p className="credits-modal__footer">
                * 후원은 DSM-TCG 운영비에 사용됩니다
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

